module.exports = __webpack_public_path__ + "img/h-page4-11.18cb7763.png";